/**
 * Shared surface styling for dropdown papers (Select / Autocomplete / SelectPopover).
 * - Dark-mode-only light border; transparent in light mode so toggling schemes causes no layout shift.
 * - `backgroundImage: none` neutralizes MUI's dark-mode elevation overlay so all three
 *   share the same flat `background.paper` (otherwise Select/SelectPopover at elevation 8
 *   look lighter than Autocomplete at elevation 1).
 * Works as both a `styleOverrides` CSS object and an `sx` object.
 */
export const DROPDOWN_SURFACE = {
  border: "1px solid light-dark(transparent, var(--mui-palette-grey-700))",
  backgroundImage: "none",
};
